import { ReactSVG } from "react-svg";
import { useDispatch } from "react-redux";
import {
  DELETE_BARCHIVE,
  SET_SHOW_BARCHIVE_BOX,
} from "../../../../../../redux/action/cases/add/type";
import { DELETE_ITEM_BARCHIVE_IN_EDIT_FORM_CASE } from "../../../../../../redux/action/cases/edit/type";

const AddCaseContactsListItem = (props) => {
  const dispatch = useDispatch();

  const deleteItem = () => {
    if (props.edit) {
      dispatch({
        type: DELETE_ITEM_BARCHIVE_IN_EDIT_FORM_CASE,
        payload: props.id,
      });
    } else {
      dispatch({
        type: DELETE_BARCHIVE,
        payload: props.id,
      });
    }
  };

  const setShowModal = () => {
    props.setEditItemBarchive({
      id: props.id,
      branch_name: props.branch_name,
      baygani_code: props.baygani_code,
    });
    dispatch({
      type: SET_SHOW_BARCHIVE_BOX,
      payload: {
        show: true,
        movakel: props.location,
      },
    });
    document.body.classList.add("modal-opened");
  };

  return (
    <div className="bg-white gap-3.5 shadow-custom-md border border-primary/10 rounded-xl p-3 flex items-center justify-between flex-wrap relative before:absolute before:w-0.5 before:h-14 before:rounded-xl before:my-auto before:bottom-0 before:bg-primary before:top-0 before:right-0">
      <div className="flex-shrink-0 flex items-center gap-3">
        <div
          className={`flex-shrink-0 w-11 h-11 "bg-slate-200" border-2 border-slate-200 shadow-lg rounded-xl`}
        >
          <span className="text-center flex items-center justify-center h-full w-full">
            <ReactSVG
              src={`${process.env.PUBLIC_URL}/assets/images/icons/lawyer.svg`}
              className="w-7"
            />
          </span>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-medium"> {props.branch_name} </span>

          {props.baygani_code && (
            <span className="text-gray-500 text-sm">
              {" "}
              {props.baygani_code}{" "}
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-1 sm:h-full h-11 mr-auto">
        <button
          onClick={setShowModal}
          type="button"
          className="h-full w-12 flex items-center justify-end text-primary duration-300 outline-none"
        >
          <ReactSVG
            src={`${process.env.PUBLIC_URL}/assets/images/icons/edit-2.svg`}
            className="w-7"
          />
        </button>

        <button
          onClick={deleteItem}
          type="button"
          className="h-full w-9 flex items-center justify-end text-red-500 hover:text-red-600 duration-300 outline-none"
        >
          <ReactSVG
            src={`${process.env.PUBLIC_URL}/assets/images/icons/times.svg`}
            className="w-6"
          />
        </button>
      </div>
    </div>
  );
};

export default AddCaseContactsListItem;
